import { ReferralApi } from "@jti/rest-api";

import { TAGS } from "../common/tags";
import { convertApiError } from "../convertApiError";
import type { LoyaltyApiBuilder } from "../loyaltyApi.types";

export type VerifyLoyaltyReferralCodeEndpointArgs = { referralCode: string; ciam_token?: string };

export const verifyLoyaltyReferralCodeEndpoint = (builder: LoyaltyApiBuilder) => ({
  verifyLoyaltyReferralCode: builder.mutation<boolean, VerifyLoyaltyReferralCodeEndpointArgs>({
    queryFn: async ({ referralCode, ciam_token }) => {
      try {
        const referralApi = ReferralApi.init();
        const isValid = await referralApi.verifyCode(referralCode, ciam_token ?? "");
        return { data: isValid };
      } catch (error: unknown) {
        return convertApiError(error);
      }
    },
    invalidatesTags: [TAGS.LOYALTY_REFERRAL],
  }),
});
